angular.module('task-project', ['core', 'files', 'document', 'clients'])
    .factory('TaskProject', function ($resource) {
        return $resource('/crm/api/task-project/:id', {id: "@id"}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/task-project/table'},
            remove: {method: 'DELETE'},
            get: {method: 'GET'},
            update: {method: 'PUT'}
        });
    })

    .service('TaskProjectService', function (TaskProject, modals, $rootScope) {
        this.add = () => {
            return modals.open('app/task/task-project/edit-modal.html', 'TaskProjectEditController', null, {size: "md"}, "$ctrl").then(() => $rootScope.$broadcast('task-project.updated'))
        }
        this.show = (id) => {
            return modals.open('app/task/task-project/show-modal.html', 'TaskProjectShowController', {id: id}, {size: "lg"}, "$ctrl")
        }
        this.edit = (id) => {
            return modals.open('app/task/task-project/edit-modal.html', 'TaskProjectEditController', {id: id}, {size: "md"}, "$ctrl").then(() => $rootScope.$broadcast('task-project.updated'))
        }
        this.delete = (project) => {
            return modals.confirmDelete(project.name, () => TaskProject.delete({id: project.id}).$promise.then(() => $rootScope.$broadcast('task-project.deleted')));
        }
    })
    .component('taskProjectList', {
        bindings: {
            // page: '<',
            // filters: '<'
        },
        templateUrl: 'app/task/task-project/list.html',
        controller: function ($q, $scope, $state, modals, TaskProject, TaskProjectService, TaskProjectGroup, TaskProjectGroupService) {
            this.TaskProjectService = TaskProjectService
            this.TaskProjectGroupService = TaskProjectGroupService

            this.$onInit = () => {
                this.show = {}
                this.newProject = null
                this.selected = $state.params.project || []
                // this.projectNone = $state.params.projectNone
                this.refresh()
            }

            this.refreshVariables = () => {
                this.groups.forEach(group => group.projects = this.projects.filter(project => project.group != null && project.group.id === group.id) || [])
                this.projectsUngrouped = this.projects.filter(project => project.group == null)
                this.isSelectedAll = this.projects.length > 0 && this.projects.map(project => project.id).every(projectId => this.selected.includes(projectId));
            }

            this.refresh = () => {
                let groupsPromise = TaskProjectGroup.query().$promise.then(items => this.groups = items);
                let projectsPromise = TaskProject.query().$promise.then(items => this.projects = items);
                return $q.all([groupsPromise, projectsPromise]).then(() => this.refreshVariables())
            }

            this.onProjectToggle = (projectId) => {
                let selectedCopy = angular.copy(this.selected)
                if(this.isSelected(projectId)) {
                    selectedCopy.splice(this.selected.indexOf(projectId), 1)
                }
                else {
                    selectedCopy.push(projectId)
                }
                this.selected = selectedCopy
                this.refreshVariables()
                $state.go($state.current, {project: this.selected}, {inherit: true, reload: false, notify: false});
            }
            // this.toggleProjectNone = () => {
            //     if(this.projectNone === true){
            //         delete this.projectNone
            //     }
            //     else {
            //         this.projectNone = true
            //     }
            //     this.refreshVariables()
            //     $state.go($state.current, {projectNone: this.projectNone}, {inherit: true, reload: false, notify: false});
            // }
            this.isSelected = (projectId) => {
                return this.selected && this.selected.includes(projectId)
            }
            this.isGroupSelected = (group) => {
                return group.projects?.length > 0 && group.projects?.every(project => this.isSelected(project.id))
            }
            this.onGroupToggle = (group) => {
                // let selectedCopy = angular.copy(this.selected)
                if(this.isGroupSelected(group)){
                    this.selected = this.selected.filter(projectId => !group.projects.map(project => project.id).includes(projectId))
                }
                else {
                    this.selected = this.selected.concat(group.projects.map(project => project.id))
                }
                // this.selected = selectedCopy
                this.refreshVariables()
                $state.go($state.current, {project: this.selected}, {inherit: true, reload: false, notify: false});
            }

            this.save = () => {
                TaskProject.save({name: this.newProject}).$promise.then(() => {
                    // this.newProject = null
                    // this.refresh()
                    this.$onInit()
                });
            }
            this.selectAllProjects = () => {
                if(this.isSelectedAll !== true){
                    this.selected = this.projects.map(project => project.id);
                }
                else {
                    this.selected = [];
                }
                this.refreshVariables()
                $state.go($state.current, {project: this.selected}, {inherit: true, reload: false, notify: false});
            }
            this.toggleShow = (projectId) => {
                this.show[projectId] = !this.show[projectId]
            }
            this.toggleShowNoGroup = () => {
                this.showNoGroup = !this.showNoGroup
            }
            $scope.$on('task-project.updated', () => this.$onInit());
            $scope.$on('task-project.deleted', () => this.refresh());
            $scope.$on('task-project-group.updated', () => this.$onInit());
            $scope.$on('task-project-group.deleted', () => this.refresh());
        }
    })
    .component('taskProjectShow', {
        bindings: {
            item: '<'
        },
        templateUrl: 'app/task/task-project/show.html',
        controller: function ($scope, $state, $window) {
            this.cancel = () => {
                if ($window.history.length > 2) {
                    $window.history.back()
                } else {
                    $state.go('taskList')
                }
            }

            $scope.$on('task-project.updated', () => $state.reload())
            $scope.$on('task-project.deleted', () => this.cancel())
            $scope.$on('file.saved', () => $state.reload())
        }
    })
    .controller('TaskProjectEditController', function ($scope, $uibModalInstance, TaskProject, TaskProjectGroup, data) {
        this.$onInit = () => {
            if(data?.id == null) {
                this.item = {}
            }
            else {
                TaskProject.get({id: data.id}).$promise.then((project) => this.item = project)
            }
            TaskProjectGroup.query().$promise.then(items => this.groups = items);
        }
        this.cancel = () => $uibModalInstance.dismiss('cancel')
        this.save = () => {
            let $promise
            if (this.item.id != null) {
                $promise = TaskProject.update(this.item).$promise
            } else {
                $promise = TaskProject.save(this.item).$promise
            }
            return $promise.then(item => $uibModalInstance.close(item))
        }
    })
    .controller('TaskProjectShowController', function ($scope, $uibModalInstance, TaskProject, data) {
        this.$onInit = () => {
            TaskProject.get({id: data.id}).$promise.then((project) => this.item = project)
        }
        this.cancel = () => $uibModalInstance.dismiss('cancel')
        $scope.$on('task-project.updated', () => this.$onInit());
        $scope.$on('task-project.deleted', () => this.cancel());
    })
    .config(function ($stateProvider) {
        $stateProvider.state('taskProjectShowFull', {
            parent: 'app',
            url: '/task-project/{id}',
            data: {
                authorities: ['ROLE_TODO']
            },
            views: {
                'content@': 'taskProjectShow'
            },
            resolve: {
                item: (TaskProject, $stateParams) => TaskProject.get({id: $stateParams.id}).$promise
            }
        })
    })
